<template>
    <div class="itemgroup-detail">
        <v-container>
            <v-card>
                <v-card-title style="background-color: rgb(33, 57, 141); color: white;">{{$t('department.department')}}</v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form v-model="valid">
                            <v-text-field
                                    v-model="form.attributes.title"
                                    :rules="titleRules"
                                    :counter="255"
                                    v-bind:label="$t('department.title')"
                                    required
                            ></v-text-field>

                            <v-autocomplete
                                    v-model="form.relationships['users'].data"
                                    :items="users"
                                    chips
                                    v-bind:label="$t('department.user')"
                                    item-text="attributes.fullname"
                                    item-value="id"
                                    multiple
                                    return-object
                            ></v-autocomplete>


                            <v-btn color="primary" @click="saveAction">
                                {{$t('message.save')}}
                            </v-btn>
                        </v-form>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        mounted() {

            this.$store.dispatch('users/loadAll').then(() => {
                const widgets = this.$store.getters['users/all'];
                widgets.forEach((item) => {
                    this.users.push(item);
                });
            });

            if (this.$route.params.id != null) {
                this.id = this.$route.params.id;
                this.$store.dispatch('departments/loadById', {id: this.id}).then(() => {
                    const widget = this.$store.getters['departments/byId']({id: this.id});
                    this.form.attributes = widget.attributes;
                    this.form.id = widget.id;
                    this.form.type = widget.type;
                    const parent = widget;
                    this.$store.dispatch('users/loadRelated', {parent}).then(() => {
                        const related = this.$store.getters['users/related']({parent});
                        console.log(this.form);
                        this.form.relationships['users'].data = [];
                        this.form.relationships['users'].data = related;
                    });
                });
            } else {

            }



        },
        methods: {
            ...mapActions({
                delete: 'departments/delete',
            }),

            saveAction: function () {
                if (this.$route.params.id != null) {
                    //this.form.id = this.$route.params.id;
                    var widget = this.$store.getters['departments/byId']({id: this.form.id});
                    widget = this.form;
                    //console.log(this.form);
                    widget.relationships['users'].data.forEach(function (item) {
                        delete item.relationships;
                        delete item.attributes;
                        delete item.links;
                        return item;
                    });
                    this.$store.dispatch('departments/update', widget).then(() => {
                         this.$router.back();
                    });
                } else {
                    var widget = this.form;

                    widget.relationships['users'].data.forEach(function (item) {
                        delete item.relationships;
                        delete item.attributes;
                        delete item.links;
                        return item;
                    });

                    if(widget.relationships['users'].data[0].type == undefined)
                        delete widget.relationships['users'];

                    this.$store.dispatch('departments/create', widget).then(() => {
                         this.$router.back();
                    });
                }
            }

        },
        computed: {
            ...mapGetters({
                loading: "departments/isLoading",
                error: "departments/isError",
            }),
        },
        data: () => ({

            form: {
                attributes: {
                    title: '',
                },
                relationships: {
                    'users': {data: []},
                },
            },

            valid: false,
            id: null,
            title: '',
            titleRules: [
                v => !!v || 'Name is required',
                v => v.length <= 255 || 'Name must be less than 255 characters'
            ],
            users: [],
        })
    }
</script>
